import { useState, useCallback, Fragment } from "react";

export const useAsyncError = () => {
    // eslint-disable-next-line
    const [_, setError] = useState(null);

    return useCallback(
        (error) => {
            if (error instanceof Error) {
                setError(() => {
                    throw error;
                });
            } else {
                setError(() => {
                    throw new Error(error, {
                        cause: new Error("Unknown Error"),
                    });
                });
            }
        },
        [setError]
    );
};

export class ExtendedError extends Error {
    constructor(message, { cause = null, ...rest } = {}) {
        super(message);
        this.cause = cause;
        Object.assign(this, rest);
    }
}

export function ErrorMessage(props) {
    return (
        <Fragment>
            {props.title && (
                <h1 className="mb-4 text-xl font-bold">{props.title}</h1>
            )}
            {props.children}
        </Fragment>
    );
}
